import { Component, Input, OnInit } from '@angular/core';
import {EvaluationBaseTileComponent} from '../tile.component';
import {LicenseService} from '../../../../services/license.service';
import {EnvironmentService} from '../../../../services/environment.service';

@Component({
    selector: 'itpx-evaluation-archive-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.css']
})
export class EvaluationArchiveTileComponent extends EvaluationBaseTileComponent implements OnInit {
    @Input() deliverable: any;

    private images : string;
    private href : string = '#';

    constructor(
        private licenseService: LicenseService,
        private environmentService: EnvironmentService
    ) {
        super();
    }

    ngOnInit() {
        this.images = this.environmentService.config['server'].images;
        super.init(this.licenseService, this.deliverable, false);
    }

    complete(deliverable: any, createTarget: boolean) {
        this.licenseService.getEvaluationArchiveFileUrl(deliverable.id)
            .subscribe(
            body => {
                if(!deliverable.disabled)
                  this.href = body.data;
                super.complete(deliverable, createTarget);
            },
            error => {
                deliverable.status = 'error';
                super.complete(deliverable, createTarget);
            }
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/evaluation/content/archive/tile.component.ts